<template>
  <section id="search" class="">
    <b-field :label="$t('search')">
      <b-input
        type="search"
        custom-class="has-background-grey has-text-light"
        icon="magnify"
        v-model="query"
        @keyup.enter.native="search"
        :placeholder="$t('search.placeholder')">
      </b-input>
    </b-field>
  </section>
</template>

<script>

import log from 'util/log'

export default {
  data () {
    return {
      query: ''
    }
  },
  computed: {
    icon: function () { return this.play ? 'pause' : 'play' }
  },
  methods: {
    search () {
      // hack to get over search result component updated called twice
      this.$store.dispatch('clearSearch')
      this.$store.dispatch('search', this.query)
        .then((result) => {
          if (result && result.geometry) {
            this.$map.fitTo({
              bbox: this.$map.bbox(result.geometry),
              srid: this.$conf.api.srid || 'EPSG:4326'
            })
            this.query = ''
          }
        })
        .catch(err => {
          log('danger', this.$t('search.error'))
          this.query = ''
        })
    }
  }
}

</script>

<style lang="stylus">

#search
  margin: 6px 6px 26px 6px
  label
    color: white
  .input
    &::placeholder
      color: white
      opacity: 1
    &:-ms-input-placeholder
      color: white
    &::-ms-input-placeholder
      color: white
    &:focus
      border: 1px solid white
      box-shadow: none
  .control.has-icons-left .input:focus ~ .icon
    color: white
</style>
